import { CharlieUser } from 'auth/types'

import { SegmentTrackAction } from './segment'

import {
  InsightsCloseSurveyType,
  InsightsDiversityViewedType,
  InsightsEqualityDetailsViewedType,
  InsightsEqualityViewedType,
  InsightsExperienceViewedType,
  InsightsSelfAssessmentFinishedType,
  InsightsSelfAssessmentStartedType,
  InsightsSelfAssessmentViewedType,
  InsightsStrategyViewedType,
  InsightsSurveyViewedType,
  InsightsTaskRejectedType,
  InsightsTaskStatusChangedType,
  InsightsTaskViewedType,
} from './types'

export const insightsSurveyViewedEvent = (
  properties: InsightsSurveyViewedType,
  user: CharlieUser
) => {
  SegmentTrackAction('insights survey viewed', properties, user)
}

export const insightsAssessmentViewedEvent = (
  properties: InsightsSelfAssessmentViewedType,
  user: CharlieUser
) => {
  SegmentTrackAction('insights assessment viewed', properties, user)
}

export const insightsSelfAssessmentStartedEvent = (
  properties: InsightsSelfAssessmentStartedType,
  user: CharlieUser
) => {
  SegmentTrackAction('insights assessment started', properties, user)
}

export const insightsSelfAssessmentFinishedEvent = (
  properties: InsightsSelfAssessmentFinishedType,
  user: CharlieUser
) => {
  SegmentTrackAction('insights assessment finished', properties, user)
}

export const insightsEqualityViewedEvent = (
  properties: InsightsEqualityViewedType,
  user: CharlieUser
) => {
  SegmentTrackAction('insights equality viewed', properties, user)
}

export const insightsEqualityDetailsViewedEvent = (
  properties: InsightsEqualityDetailsViewedType,
  user: CharlieUser
) => {
  SegmentTrackAction('insights equality details viewed', properties, user)
}

export const insightsDiversityViewedEvent = (
  properties: InsightsDiversityViewedType,
  user: CharlieUser
) => {
  SegmentTrackAction('insights diversity viewed', properties, user)
}

export const insightsExperienceViewedEvent = (
  properties: InsightsExperienceViewedType,
  user: CharlieUser
) => {
  SegmentTrackAction('insights experience viewed', properties, user)
}

export const insightsStrategyViewedEvent = (
  properties: InsightsStrategyViewedType,
  user: CharlieUser
) => {
  SegmentTrackAction('insights strategy viewed', properties, user)
}

export const insightsTaskViewedEvent = (
  properties: InsightsTaskViewedType,
  user: CharlieUser
) => {
  SegmentTrackAction('insights task viewed', properties, user)
}

export const insightsTaskStatusChangedEvent = (
  properties: InsightsTaskStatusChangedType,
  user: CharlieUser
) => {
  SegmentTrackAction('insights task status changed', properties, user)
}

export const insightsTaskRejectedEvent = (
  properties: InsightsTaskRejectedType,
  user: CharlieUser
) => {
  SegmentTrackAction('insights task rejected', properties, user)
}

export const insightsCloseSurveyEvent = (
  properties: InsightsCloseSurveyType,
  user: CharlieUser
) => {
  SegmentTrackAction('insights survey closed', properties, user)
}
